import {CanvasComponent} from "../canvas/canvas.component";
import {CanvasRenderer, StateInfoItem} from "./stateinfoitemrendererfactory";


export class HighlightedElement implements StateInfoItem {
    type: string = "HighlightElement";
    referenceOverDisplaced: boolean;
    showReferenceCrosshair: boolean;
    showDisplacedCrosshair: boolean;
    color: string;
    isvisible: boolean;
    relativePositions: boolean;

    // TODO: use new typescript feature "Partial" for initializing with Objects
    constructor(position: any, showDisplacedCrosshair?: boolean, color?: string, isVisible?: boolean, relativePositions: boolean = false) {
        this.position = position;
        this.color = color || 'red';
        this.showDisplacedCrosshair = showDisplacedCrosshair;
        this.isvisible = isVisible;
        this.relativePositions = relativePositions;
    }

    position: {
        x: number,
        y: number,
        width: number,
        height: number,
    }

}



export class HighlightedElementCanvasRenderer implements CanvasRenderer {

    renderRectanble(paperjsScope: any, position: any, color: string, drawCrosshair: boolean, isVisible: boolean, relativePosition: boolean = false) {
        let xPosition;
        let yPosition;
        let width;
        let height;

        if (relativePosition) {
            const viewBounds = paperjsScope.project.layers[0]?.bounds;

            xPosition = viewBounds.width * position['x'];
            yPosition = viewBounds.height * position['y'];
            width = viewBounds.width * position['width'];
            height = viewBounds.height * position['height'];

            let layer = new paperjsScope.Layer();
            layer.name = "highlightedelements";
            layer.activate();

        } else {
            xPosition = position['x'];
            yPosition = position['y'];
            width = position['width'];
            height = position['height'];
        }

        let rect = new paperjsScope.Rectangle(xPosition, yPosition, width, height);
        let path = new paperjsScope.Path.Rectangle(rect);
        path.strokeColor = color;
        path.strokeWidth = 2;
        if (!isVisible){
            path.dashArray = [10,12];
            path.fillColor = new paperjsScope.Color(0.8, 0.8, 1, 0.5);
        }

        if (drawCrosshair) {
            let crosshairLeft = new paperjsScope.Path.Line(
                new paperjsScope.Point(0, position.y + position.height / 2),
                new paperjsScope.Point(position.x, position.y + position.height / 2)
            );
            crosshairLeft.strokeColor = color;
            crosshairLeft.strokeWidth = 1;

            let crosshairTop = new paperjsScope.Path.Line(
                new paperjsScope.Point(position.x + position.width / 2, 0),
                new paperjsScope.Point(position.x + position.width / 2, position.y)
            );
            crosshairTop.strokeColor = color;
            crosshairTop.strokeWidth = 1;

        }
    }

    renderToCanvas(element: HighlightedElement, canvas: CanvasComponent) {
        let scope = canvas.activateAndGetPaperScope();
        this.renderRectanble(scope, element.position, element.color, element.showDisplacedCrosshair, element.isvisible, element.relativePositions);
    }

}
